module.exports = __webpack_public_path__ + "static/media/correct.998ae014.svg";